import configurationsApi from './api';
import configurationsToasts from './toasts';

export default [configurationsApi(), configurationsToasts()];
